import { cn } from "@/lib/utils"

export const TypographyH1 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h1
      className={cn(
        "scroll-m-20 text-center text-4xl font-extrabold tracking-tight text-balance",
        className
      )}
      {...props}
    ></h1>
  )
}

export const TypographyH2 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h2
      className={cn(
        "scroll-m-20 pb-2 text-3xl font-semibold tracking-tight first:mt-0",
        className
      )}
      {...props}
    ></h2>
  )
}

export const TypographyP = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className={cn("leading-7 [&:not(:first-child)]:mt-6", className)}
      {...props}
    ></p>
  )
}

export const TypographyBlockquote = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLQuoteElement>) => {
  return (
    <blockquote
      className={cn("mt-6 border-l-2 pl-6 italic", className)}
      {...props}
    ></blockquote>
  )
}

export const TypographyList = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLUListElement>) => {
  return (
    <ul
      className={cn("my-6 ml-6 list-disc [&>li]:mt-2", className)}
      {...props}
    ></ul>
  )
}

export const TypographyInlineCode = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) => {
  return (
    <code
      className={cn(
        "bg-muted relative rounded px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold",
        className
      )}
      {...props}
    ></code>
  )
}

export const TypographyLead = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className={cn("text-muted-foreground text-xl", className)}
      {...props}
    ></p>
  )
}

export const TypographyLarge = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn("text-lg font-semibold", className)} {...props}></div>
  )
}

export const TypographySmall = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) => {
  return (
    <small
      className={cn("text-sm leading-none font-medium", className)}
      {...props}
    ></small>
  )
}

export const TypographyMuted = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className={cn("text-muted-foreground text-sm", className)}
      {...props}
    ></p>
  )
}

export const TypographyError = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p className={cn("text-destructive text-sm", className)} {...props}></p>
  )
}
